import { Map, fromJS } from 'immutable';
import { ajaxHandler } from './AjaxHandler';

/* eslint no-undef: 0 */
const Config = window.vfEnvironmentConfig;

const DEFAULT_PARAMS = Map({
    include_travel_professionals: 'true',
    vertical_id: '5',
    is_contactable: '1',
});

export default class SpartaService {
    buildQuery(params) {
        const parameters = params instanceof Map ? DEFAULT_PARAMS.merge(params) : DEFAULT_PARAMS.merge(fromJS(params));

        let separator = '?';
        return encodeURI(parameters.reduce((query, value, key) => {
            const reduced = `${query}${separator}${key}=${value}`;
            separator = '&';
            return reduced;
        }, ''));
    }

    search(params) {
        const query = this.buildQuery(params);
        return this.api(`${Config.API_URL}/v2/public/stats-mortgages${query}`).get(params);
    }

    isValidResponse(response) {
        return response && response.data && JSON.parse(response.data) && JSON.parse(response.data).data.total_count > 0;
    }

    isNoContent(status) {
        return status === 204;
    }

    getStats(params) {
        return new Promise((resolve, reject) => {
            this.search(params).then(
                response => {
                    if (!this.isValidResponse(response) || this.isNoContent(response.status)) {
                        resolve({
                            reviewsCount: 21,
                            averageScore: 4.4,
                            total: 1,
                        });

                        return;
                    }

                    const responseData = JSON.parse(response.data).data;

                    const stats = {
                        reviewsCount: responseData.service_review_count,
                        averageScore: responseData.review_average_score,
                        total: responseData.total_count,
                    };

                    resolve(stats);
                }
            ).catch(
                error => {
                    reject(error);
                }
            );
        });
    }

    api(url) {
        return {
            get: (params) => ajaxHandler('GET', url, params),
        };
    }
}



// WEBPACK FOOTER //
// ./src/services/SpartaService.js